import { render, staticRenderFns } from "./NuvemShop.vue?vue&type=template&id=bb015c72"
import script from "./NuvemShop.vue?vue&type=script&lang=js"
export * from "./NuvemShop.vue?vue&type=script&lang=js"
import style0 from "./NuvemShop.vue?vue&type=style&index=0&id=bb015c72&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports